<template>
    <div class="mx-auto container">
        <div class="row mt-4 ml-4">
            <div class="form-group col-lg-3">
                <label for="Search" class="h5">{{
                    labelUpdated.searchTextLabel
                }}</label>
                <input id="Search" value="" name="Search" type="text" class="form-control"
                    :placeholder="labelUpdated.searchPlaceholderText" v-model="searchText" />
                <!-- <p class="invalid-feedback" role="alert">Invalid Zip Code Format</p> -->
            </div>
            <div class="form-group col-lg-3">
                <label for="Sort" class="h5">{{
                    labelUpdated.dropdownLabel
                }}</label>
                <select id="Sort" name="Sort" class="custom-select btn--select form-control" aria-required="true"
                    required v-model="selectedCategory">
                    <option value="">All</option>
                    <option v-for="option in parsedDropdownValues" :key="option.Value" :value="option.Value">
                        {{ option.Text }}
                    </option>
                </select>
                <p class="invalid-feedback" role="alert">
                    Course Selection Required
                </p>
            </div>
            <div class="form-group col-lg-3">
                <label for="Sort" class="h5">{{ labelUpdated.fromDateLabel }}</label>
                <div class="row">
                    <div class="form-group col-lg-12">
                        <input required="" type="text" class="form-control" v-model="formDate"
                            :placeholder="labelUpdated.fromDateLabel" onfocus="(this.type='date')" />
                    </div>

                </div>
            </div>
            <div class="form-group col-lg-3">
                <label for="Sort" class="h5 ml-3">{{ labelUpdated.toDateLabel }}</label>
                <div class="form-group col-lg-12">
                    <input required="" type="text" class="form-control" v-model="toDate"
                        :placeholder="labelUpdated.toDateLabel" onfocus="(this.type='date')" />
                    <!-- <label for="toDate" class="form-placeholder">To</label> -->
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-end mr-3">
            <p class="text-danger date-error-msg" v-if="validationDate">
                Please verify that the <b>'To date'</b> is lesser than the
                <b>'From date</b>.
            </p>
        </div>
        <div class="d-flex justify-content-start ml-3">
            <div class="mr-3">
                <button class="btn btn-round btn-primary" type="submit"
                    data-analytics-campaign='{"id":123, "name":"search button"}' @click="handleSearchResult">
                    {{ labelUpdated.searchButtonText }}
                </button>
            </div>
            <div class="ml-4">
                <button class="btn btn-round btn-outline-primary custom-clear-filter-btn"
                    data-analytics-campaign='{"id":123, "name":"clear filter button"}' @click="handleClearFilter">
                    {{ labelUpdated.clearFiltersText }}
                </button>
            </div>
        </div>

        <!-- Render Paginated Results -->
        <div class="row justify-content-start ml-1 mt-1 ml-3 p-4 flex-column">
            <div class="mt-4" v-for="(item, index) in paginatedResults" :key="index">
                <div class="d-flex justify-content-start mt-3 font-weight-bold">
                    <p>{{ item.Category }}</p>
                    <!-- <p class="ml-2">{{ item.ProposalDate || "TBD" }}</p> -->
                </div>
                <a  :href="item.Link || ''"  :target="item.LinkTarget || ''" class="title-text h5 font-weight-bold item-title">{{
                    item.Title
                }}</a>
                <p v-html="item.Description"></p>

                <div v-if="item.PreProposalDate !== null">
                    <div> {{ labelUpdated.preProposalDeadline }} {{ item.PreProposalDate }}</div>
                </div>
                <div v-else-if="item.ProposalDate !== null">
                    <div> {{ labelUpdated.proposalDate }} {{ item.ProposalDate }}</div>
                </div>
                <div v-else="item.TBD !== null">
                    <div>{{ labelUpdated.tbdLabel }}</div>
                </div>
            </div>
        </div>

        <!-- Pagination Navigation -->
        <div class="d-flex justify-content-between ">
            <div v-if="totalLength > 0">
                <nav>
                    <ul class="pagination pagination-lg pagination--page-count pagination--right funding-opportunities">
                        <li class="page-item" :class="{ disabled: currentPageNo === 1 }">
                            <button class="page-link" @click="prevPage">
                                <i class="icon-left-arrow"></i>
                                <span class="sr-only">Previous</span>
                            </button>
                        </li>

                        <!-- Display page numbers -->
                        <li class="page-item" v-for="page in totalPages" :key="page"
                            :class="{ active: page === currentPageNo }">
                            <button class="page-link" @click="setPage(page)">
                                {{ page }}
                            </button>
                        </li>

                        <li class="page-item" :class="{ disabled: currentPageNo === totalPages }">
                            <button class="page-link" @click="nextPage">
                                <i class="icon-right-arrow"></i>
                                <span class="sr-only">Next</span>
                            </button>
                        </li>
                    </ul>
                </nav>
            </div>
            <div v-else>
                <p class="mt-3 ml-4 pl-3 font-weight-bold" v-html="noResultsMessage"></p>

            </div>
            <!-- <div class="d-flex mt-3 justify-content-center align-center">
          <label class="h5 mt-2 ml-2">Results per page</label>
          <div class="ml-2">
            <button class="page-item"
              v-for="size in [5, 10, 30, 50]"
              :key="size"
              :class="['btn', pageSize === size ? 'selected-button' : 'btn-outline-primary']"
              @click="setPageSize(size)"
            >
              {{ size }}
            </button>
          </div>
      </div> -->
        </div>
    </div>
</template>

<script>
import axios from "axios";
export default {
    props: {
        results: {
            type: Array,
            required: true,
        },
        dropDownValues: {
            type: Array,
            required: true,
        },
        translations: {
            type: Object,
            required: true,
        },
        pageSize: {
            type: Number,
            required: true,
        },
        searchEndpoint: {
            type: String,
            required: true,
        },
        noResultsMessage: {
            type: String,
            required: true,
        },


    },
    data() {
        return {
            currentPageNo: 1,
            pageSize: this.pageSize, // Default number of results per page
            selectedCategory: "",
            searchText: "",
            formDate: "",
            toDate: "",
            validationDate: false,
            totalLength: 0,
        };
    },
    computed: {

        parsedResult() {
            console.log('translations', this.translations)
            // Check if this.results is defined and not null
            if (this.results == null) {
                this.totalLength = 0; // Set totalLength to 0 for null results
                return null; // Return null for empty results
            }

            // Check if this.results is a string
            if (typeof this.results === "string") {
                // Handle encoded quotes
                if (this.results.includes("&quot;")) {
                    const decodedString = this.results.replace(/&quot;/g, '"');
                    const parsedData = JSON.parse(decodedString);
                    this.totalLength = Array.isArray(parsedData)
                        ? parsedData.length
                        : Object.keys(parsedData).length;
                    return parsedData;
                } else {
                    // Attempt to parse directly if no encoded quotes are found
                    try {
                        const parsedData = JSON.parse(this.results);
                        this.totalLength = Array.isArray(parsedData)
                            ? parsedData.length
                            : Object.keys(parsedData).length;
                        return parsedData;
                    } catch (error) {
                        console.error("Error parsing JSON:", error);
                        this.totalLength = 0; // Reset totalLength on parse error
                        return null; // Return null if parsing fails
                    }
                }
            } else if (Array.isArray(this.results)) {
                // If this.results is already an array, calculate totalLength
                this.totalLength = this.results.length;
                return this.results;
            } else if (
                typeof this.results === "object" &&
                this.results !== null
            ) {
                // If this.results is an object, calculate totalLength based on keys
                this.totalLength = Object.keys(this.results).length;
                return this.results;
            } else {
                // Handle unexpected types
                this.totalLength = 0; // Reset totalLength for unexpected types
                return null; // Return null for unexpected types
            }
        },
        parsedDropdownValues() {
            const decodedString = this.dropDownValues.replace(/&quot;/g, '"');
            return JSON.parse(decodedString);
        },
        labelUpdated() {
            const decodedString = this.translations.replace(/&quot;/g, '"');
            return JSON.parse(decodedString);
        },
        paginatedResults() {
            const start = (this.currentPageNo - 1) * this.pageSize;
            const end = start + this.pageSize;
            return this.parsedResult.slice(start, end);
        },
        totalPages() {
            return Math.ceil(this.parsedResult.length / this.pageSize);
        },

    },
    methods: {
        handleSearchResult() {
            // console.log ( this.pageSize, this.searchText, this.selectedCategory, this.c, this.toDate)
            //this.validationDate = this.toDate <= this.formDate;

            if (this.formDate !== "" && this.toDate !== "") {
                if (this.toDate <= this.formDate) {
                    this.validationDate = true;
                } else {
                    this.validationDate = false;
                }
            }

            axios
                .post(
                    `${this.searchEndpoint}?pageSize=${this.pageSize}&searchText=${this.searchText}&category=${this.selectedCategory}&fromDate=${this.formDate}&toDate=${this.toDate}`
                )
                .then((res) => {
                    this.results = res.data;
                    const parsed = this.parsedResult("json");
                    console.log(parsed);
                })
                .catch((err) => console.log(err));
        },
        handleClearFilter() {
            this.searchText = "";
            this.selectedCategory = "";
            this.toDate = "";
            this.formDate = "";
            this.validationDate = false;
            this.handleSearchResult()
        },
        setPage(page) {
            this.currentPageNo = page;
        },
        prevPage() {
            if (this.currentPageNo > 1) {
                this.currentPageNo--;
            }
        },
        nextPage() {
            if (this.currentPageNo < this.totalPages) {
                this.currentPageNo++;
            }
        },
        setPageSize(size) {
            this.pageSize = size;
            this.currentPageNo = 1; // Reset to the first page when page size changes
        },
    },
};
</script>

<style>
/* Style for the selected button */
.selected-button {
    background-color: #e9ecef !important;
    /* Change this to the desired color */
    color: #222328 !important;
    /* Ensure text is visible */
    border-color: #dee2e6 !important;
}

.btn-group .btn {
    margin-right: 5px;
}

.page-link {
    color: black !important;
}

.date-error-msg {
    margin-left: 10px;
}

.title-text {
    color: #c10e21;
    text-decoration: underline;
    margin-bottom: 10px !important;
}

.custom-clear-filter-btn {
    background-color: transparent !important;
    color: #c10e21 !important;
    border: 1px solid #c10e21 !important;
}

.item-title:hover {
    color: #c10e21;
    text-decoration: underline;
}

.funding-opportunities .page-item.active .page-link {
    background-color: #dee2e6 !important;
}
</style>



// WEBPACK FOOTER //
// src/app/components/phd/aha-search-funding-opportunities.vue